import { render, staticRenderFns } from "./teacherMaterialAnalysis.vue?vue&type=template&id=99959ee6&scoped=true&"
import script from "./teacherMaterialAnalysis.vue?vue&type=script&lang=js&"
export * from "./teacherMaterialAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./teacherMaterialAnalysis.vue?vue&type=style&index=0&id=99959ee6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99959ee6",
  null
  
)

export default component.exports